import taskReminderSound from "../assets/task_reminder.wav";

let audioInstance = null;

const getNotificationVolume = () => {
  const stored = localStorage.getItem("volume");
  const volume = stored === null ? 1 : Number(stored);
  if (Number.isNaN(volume)) return 1;
  return Math.max(0, Math.min(1, volume));
};

/** Sonido de recordatorio de tareas (distinto al de chats/tickets). */
const playTaskReminderSound = () => {
  const volume = getNotificationVolume();
  if (volume <= 0) return;

  try {
    if (!audioInstance) {
      audioInstance = new Audio(taskReminderSound);
    }
    audioInstance.volume = volume;
    audioInstance.currentTime = 0;
    const playPromise = audioInstance.play();
    if (playPromise?.catch) {
      playPromise.catch(() => {});
    }
  } catch (err) {
    // ignore autoplay restrictions
  }
};

export default playTaskReminderSound;
